module.exports = __webpack_public_path__ + "static/media/01.c2c8fba4.jpg";